import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-app/public/images/logo/logo-3d.png");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/vercel/path0/apps/web-app/src/app/_components/auth/login-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/packages/ui/src/separator.tsx");
